import { GraphQLError } from 'graphql';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { GenericFormScene } from 'shared-ui/lib/components/generic-form-scene/GenericFormScene';
import { parseGraphqlErrors } from 'shared-ui/lib/utils/get-gql-error';
import { useParams } from 'shared-ui/lib/utils/use-params';
import { routesConfig } from '../../config/routes.config';
import {
  vehicleCreateForm,
  VehicleCreateFormBody,
} from '../../form/vehicle-create/vehicleCreate.form';
import { useCreatePartnerCustomerVehicleMutation } from '../../generated/graphql';
import { useUploadFile } from '../../hooks/use-upload-file';

export const CustomerVehicleCreateScene = (): JSX.Element => {
  const { t } = useTranslation('CustomerVehicleCreateScene');
  const navigate = useNavigate();
  const { businessId } = useParams<{ businessId: string }>();
  const [createVehicle, { loading }] = useCreatePartnerCustomerVehicleMutation();
  const { uploadFile, isImageLoading } = useUploadFile({
    type: 'vehicle-image',
  });

  const handleSubmit = async ({ photo, ...body }: VehicleCreateFormBody) => {
    const { data, errors } = await createVehicle({
      variables: { businessId, body },
    });
    if (!data) throw new Error(parseGraphqlErrors(errors as GraphQLError[]));
    await uploadFile(photo, data.createPartnerCustomerVehicle.id);
    toast.success(t('createSuccess'));
    navigate(routesConfig.SERVICE_CALL.CUSTOMERS);
  };

  return (
    <GenericFormScene
      type="create"
      title={t('addVehicle')}
      onSubmit={handleSubmit}
      onSubmitValidationFailed={() => toast.error(t('notSavedCheckFields'))}
      form={vehicleCreateForm}
      isSubmitLoading={loading || isImageLoading}
      backLink={routesConfig.SERVICE_CALL.CUSTOMERS}
    />
  );
};
